import { useState, useEffect } from 'react';

import { useTranslation } from 'react-i18next';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import '../../styles/AdminLayout.css';
import '../../styles/SidebarCommon.css';

import { ReactComponent as LogoutIcon } from '../../react-icons/logoutIcon.svg';
import { ReactComponent as SailTrackLogo } from '../../react-icons/SailTrackLogo.svg';

type Tab = {
  id: string;
  label: string;
  path: string;
};

export function AdminLayout() {
  const { t } = useTranslation('common');
  const location = useLocation();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(location.pathname.split('/')[2] || '');

  useEffect(() => {
    const current = location.pathname.split('/')[2] || '';
    setActiveTab(current);
  }, [location.pathname]);

  const tabs: Tab[] = [
    {
      id: 'crear-usuario',
      label: t('admin.createUser'),
      path: '/admin/crear-usuario',
    },
    {
      id: 'barcos',
      label: t('admin.manageBoats'),
      path: '/admin/barcos',
    },
    {
      id: 'herramientas',
      label: t('admin.tools.title'),
      path: '/admin/herramientas',
    },
    // añade más pestañas aquí si las necesitas
  ];

  const handleTabChange = (tab: Tab): void => {
    try {
      setActiveTab(tab.id);
      navigate(tab.path);
    } catch (error) {
      console.error('Error cambiando de pestaña:', error);
    }
  };

  const handleLogoClick = (): void => {
    navigate('/home');
  };

  const handleLogout = (): void => {
    localStorage.removeItem('token');
    navigate('/authUser');
  };

  return (
    <div className="adminPage-container">
      <div className="adminPage-sidebar">
        <button onClick={handleLogoClick} className="adminPage-logo-button">
          <div className="adminPage-logo-container">
            <SailTrackLogo
              className="adminPage-logo"
              role="img"
              aria-label={t('admin.adminLogoAlt')}
              focusable="false"
            />
            <span className="adminPage-logo-title">Sailtrack</span>
          </div>
        </button>

        <h2 className="adminPage-title">{t('nav.adminPanel')}</h2>
        <div className="adminPage-separator" />

        <nav className="adminPage-nav">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              className={`adminPage-nav-item ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => handleTabChange(tab)}
            >
              <span className="nav-label">{tab.label}</span>
              {activeTab === tab.id && <span className="underline-effect" />}
            </button>
          ))}
        </nav>

        <div className="adminPage-separator" />

        <div className="logout-settings-container">
          <button className="logout-button" onClick={handleLogout}>
            <LogoutIcon className="dropdown-icon" aria-label={t('nav.logout')} />
            {t('nav.logout')}
          </button>
        </div>
      </div>

      <div className="adminPage-content">
        <Outlet />
      </div>
    </div>
  );
}
